// extracted by mini-css-extract-plugin
export default {"errorImg":"NotFound_errorImg__LcinK","contentWrapper":"NotFound_contentWrapper__3oMPi","title":"NotFound_title__OQ-MU","description":"NotFound_description__GX4XL"};